module.exports = __webpack_public_path__ + "media/images/background_identity_big-1440w-6498d26d.jpg";